import React from 'react';
import CommonSVGIcon, { Props } from '@/components/icons/CommonSVGIcon';

export default function Plane(props: Props) {
  return (
    <CommonSVGIcon {...props} viewBox="0 0 24 24">
      <path fillOpacity="0.13" d="M8.25 3.81818L16.0909 5.8V18.2L8.25 20.1818V3.81818Z"/>
      <path fillOpacity="0.66" fillRule="evenodd" clipRule="evenodd" d="M7 2L16.8182 5.18182V18.8182L7 22V2ZM8.25 3.81818V20.1818L16.0909 18.2V5.8L8.25 3.81818Z"/>
    </CommonSVGIcon>
  );
}
